/**
 * The SIP trunk queries — plan-008 ST-UN. Kept beside Numbers & SIP rather than appended to
 * `src/api/query.ts`, because this unit owns `routes/numbers/**` and the slice, not the shared query
 * file (the arrangement of `routes/payouts/payout-query.ts`). ST-UA's Channels tab reads the same keys,
 * so a change on either screen refreshes both.
 *
 * There is deliberately no query for the inbound credentials: `createSipTrunkInboundAuth`'s answer
 * holds a password that is shown once, and a query cache is a place a secret would survive.
 */
import { queryOptions } from "@tanstack/react-query";

import type { ConsoleGateway } from "../../api/gateway.js";

export const SIP_TRUNK_QUERY_KEY = {
  sipTrunk: ["sip-trunk"] as const,
  sipTrunkSettings: ["sip-trunk-settings"] as const,
  sipTrunkEvent: ["sip-trunk-event"] as const,
};

export const sipTrunkListQuery = (gateway: ConsoleGateway) =>
  queryOptions({
    queryKey: SIP_TRUNK_QUERY_KEY.sipTrunk,
    queryFn: () => gateway.listSipTrunks(),
  });

/** WeTalk's SIP host and address, the ports and the reviewed countries — slow to change. */
export const sipTrunkSettingsQuery = (gateway: ConsoleGateway) =>
  queryOptions({
    queryKey: SIP_TRUNK_QUERY_KEY.sipTrunkSettings,
    queryFn: () => gateway.readSipTrunkSettings(),
    staleTime: 60_000,
  });

export const sipTrunkEventQuery = (gateway: ConsoleGateway, sipTrunkId: string) =>
  queryOptions({
    queryKey: [...SIP_TRUNK_QUERY_KEY.sipTrunkEvent, sipTrunkId],
    queryFn: () => gateway.listSipTrunkEvents(sipTrunkId),
  });
